import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider, theme } from '@chakra-ui/core';
import { SWRConfig } from 'swr';
import axios from 'axios';

import './styles/index.css';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';

import App from './components/App';

const ThemeApp = () => {
  const breakpoints = ['640px', '768px', '1024px', '1280px'];

  // aliases
  breakpoints.sm = breakpoints[0];
  breakpoints.md = breakpoints[1];
  breakpoints.lg = breakpoints[2];
  breakpoints.xl = breakpoints[3];

  const customTheme = {
    ...theme,
    breakpoints,
    fonts: {
      heading: '"CeraGRBold" ,sans-serif',
      display: '"CeraGRLight" ,sans-serif',
      medium: '"CeraGRThin" ,sans-serif',
      body: '"CeraGR", sans-serif'
    },
    fontSizes: {
      xx: '.55rem',
      tiny: '.68rem',
      '7xl': '5rem',
      '8xl': '6rem'
    },
    space: {
      ...theme.space,
      '14': '3.5rem',
      '60': '15rem',
      '70': '18rem',
      '80': '20rem',
      '85': '23rem',
      '87': '24rem',
      '90': '25rem',
      '108': '27rem',
      '110': '30rem',
      '115': '32rem',
      '120': '35rem',
      '125': '45rem',
      '127': '48rem',
      '130': '55rem',
      '135': '60rem',
      '140': '70rem',
      '145': '76rem'
    },
    sizes: {
      ...theme.sizes,
      '14': '3.5rem',
      '60': '15rem',
      '70': '18rem',
      '80': '20rem',
      '85': '23rem',
      '90': '25rem',
      '108': '27rem',
      '110': '30rem',
      '115': '32rem',
      '120': '35rem',
      '125': '45rem',
      '127': '48rem',
      '130': '55rem',
      '135': '60rem',
      '140': '70rem',
      '145': '76rem'
    },
    colors: {
      ...theme.colors,
      cf: {
        100: 'rgba(68, 95, 36, 0.04)',
        200: 'rgba(60, 145, 48, 0.1)',
        300: 'rgba(60, 145, 48, 0.05);',
        400: '#3c9130',
        500: 'rgba(60, 145, 48, 0.18);'
      }
    },
    shadows: {
      ...theme.shadows,
      1000: '0 10px 20px 0 rgba(97, 111, 57, 0.5)',
      2000: '10px 10px 20px 0 rgba(0, 0, 0, 0.1);'
    }
  };
  return (
    <ThemeProvider theme={customTheme}>
      <SWRConfig value={{ fetcher: url => axios.get(url).then(res => res.data) }}>
        <App />
      </SWRConfig>
    </ThemeProvider>
  );
};

ReactDOM.render(<ThemeApp />, document.getElementById('root'));
